import api from './api'

export const report = {
  carPresentList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/CarPresentList`, params)
  },
  deleteCarPresent: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/deleteCarPresent`, params)
  },
  carBusInfo: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/CarBusInfo`, params)
  },
  carBusPayInfo: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/carBusPayInfo`, params)
  },
  carBusPayAmountInfo: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/CarBusPayAmountInfo`, params)
  },
  carBusArrList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/CarBusArrList`, params)
  },
  roadSideCarPresentExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/RoadSideCarPresentExport`, params)
  },
  arrMainList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/ArrMainList`, params)
  },
  arrMainListExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/ArrMainListExport`, params)
  },
  arrPay: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/ArrPay`, params)
  },
  carDepartureList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/carDepartureList`, params)
  },
  outParkHisDataSum: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/OutParkHisDataSum`, params)
  },
  roadSideCarDepartureExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/roadSideCarDepartureExport`, params)
  },
  staffPerformanceList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/staffPerformanceList`, params)
  },
  pdaList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/pdaList`, params)
  },
  staffPerformanceExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/staffPerformanceExport`, params)
  },
  uploadArrData: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/UploadArrData`, params)
  },
  importArrData: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/ImportArrData`, params)
  },
  deleteArr: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/DeleteArr`, params)
  },
  createArrTemplate: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/CreateArrTemplate`, params)
  },
  handoverList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/HandoverList`, params)
  },
  handoverInfo: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/HandoverInfo`, params)
  },
  handoverPayInfo: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/HandoverPayInfo`, params)
  },
  handoverExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/RoadSideHandoverExport`, params)
  },
  handoverDetailExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/RoadSideHandoverDetailExport`, params)
  },
  handoverBusHisList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/HandoverBusHisList`, params)
  },
  editArrAmt: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/EditAmt`, params)
  },
  arrNormalAppearance: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/ArrNormalAppearance`, params)
  },
  carTurnoverList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/CarTurnoverList`, params)
  },
  carBusHisDataDelete: (id) => {
    return api.get(`/CloudParkAPI/RoadSideReport/CarBusHisDataDelete/${id}`)
  },
  carBusHisDataChangePay: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/CarBusHisDataChangePay`, params)
  },
  carBusHisDataChangeToArr: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/CarBusHisDataChangeToArr`, params)
  },
  roadSideEInvoiceDataList: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/EInvoiceDataList`, params)
  },
  roadSideRetransmitById: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/RetransmitById`, params)
  },
  roadSideModifyPlateCode: (params) => {
    return api.post(`/CloudParkAPI/RoadSideReport/ModifyPlateCode`, params)
  }

}



// WEBPACK FOOTER //
// ./src/api/roadSideReport.js